@if (orderFees) {
  <mat-card>
    <mat-card-header>
      <span class="flex-container-space-between">
        <mat-card-title>{{ 'orders.orderSummary' | transloco }}</mat-card-title>
        <lib-disclosure-indicator [isExpanded]="!collapsed" color="white"
        (click)="onCollapse()"></lib-disclosure-indicator>
      </span>
    </mat-card-header>
    <mat-card-content>
      <div [@slideDown]="collapsed ? 'hidden' : 'visible'">
        <table mat-table [dataSource]="orderFees" class="mat-elevation-z0">
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.description' | transloco }} </th>
            <td mat-cell *matCellDef="let fee"> @if (fee.id == emptyGuid) {
              <span class="expected">*
              </span>
            }{{getDescription(fee)}} </td>
          </ng-container>
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.amount' | transloco }} </th>
            <td mat-cell *matCellDef="let fee"> {{(fee.amount) | currency}} </td>
          </ng-container>
          <ng-container matColumnDef="tax">
            <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.tax2' | transloco }} </th>
            <td mat-cell *matCellDef="let fee"> {{(fee.gst + fee.pst + fee.hst) | currency}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <div class="always-showing">
        @if (!isComplete) {
          <span class="expected total">*</span>
          }<span class="total">{{ 'common.labels.totalAmount' | transloco: { amount: (totalCost | currency) } }}</span>
      </div>
      <div class="always-showing">
        @if (!isComplete) {
          <p class="expected">{{ 'orders.expected' | transloco }}</p>
        }
      </div>
    </mat-card-content>
  </mat-card>
}